import React from 'react'
import classnames from 'classnames'
import map from 'lodash/map'
import find from 'lodash/find'
import getProjectStatusForProjectsList from '@Utils/GetProjectStatusForProjectsList'
import getCleanDisplayTitle from '@Utils/GetCleanDisplayTitle'
import Return from '@Images/languages_view_return.svg'

import {
  IProjectLabelCaptions,
  IProject,
} from '@SiteModules/Project/types'

import {
  IProjectVersion,
} from '@SiteModules/ProjectVersion/types'

import './ProjectVersionsViewHeader.scss'

const NUMBER_OF_LABELS_TO_SHOW = 5
const NUMBER_OF_LABELS_TO_SHOW_FULL_VIEW = 9

interface ProjectVersionsViewHeaderProps {
  readonly fullProjectVersionsView: boolean
  readonly project: IProject | undefined
  readonly projectLabelCaptions: IProjectLabelCaptions[]
  readonly originalProjectVersion: IProjectVersion | undefined
  resetOpenedProject(): void
  handleOpenSetupProjectOrRenewSubscriptionPopup(projectVersionId: string, projectType?: string): void
}

const ProjectVersionsViewHeader: React.FC<ProjectVersionsViewHeaderProps> = props => {
  const {
    project,
    fullProjectVersionsView,
    projectLabelCaptions,
  } = props

  const labelCaptionsOfProject = project ? find(projectLabelCaptions, projectLabelCaption => projectLabelCaption.projectId === project.id) : undefined

  const labelCaptions = labelCaptionsOfProject ? labelCaptionsOfProject.captions : []
  const numberOfLabelCaptions = labelCaptions.length
  const numberOfLabelsToShow = fullProjectVersionsView ? NUMBER_OF_LABELS_TO_SHOW_FULL_VIEW : NUMBER_OF_LABELS_TO_SHOW

  const renderTitleAndStatus = () => {
    const projectVersionStatuses = project ? map(project.projectVersions, pv => pv.attributes.status) : []
    const [projectStatusClass, projectStatusToRender] = project ? getProjectStatusForProjectsList(projectVersionStatuses) : ['', '']

    return (
      <div className="ProjectVersionsViewHeader__title-status-wrapper">
        {fullProjectVersionsView && (
          <Return
            className="ProjectVersionsViewHeader__return"
            onClick={props.resetOpenedProject}
          />
        )}
        <div className="ProjectVersionsViewHeader__title">
          {project ? getCleanDisplayTitle(project.attributes.title) : ''}
        </div>
        <div className={`ProjectVersionsViewHeader__status-badge ProjectsTable__status-badge ${projectStatusClass}`}>
          {projectStatusToRender}
        </div>
      </div>
    )
  }

  const renderLabels = () => {
    return (
      <div className="ProjectVersionsViewHeader__labels-wrapper">
        <ul className="ProjectVersionsViewHeader__labels">
          {map(labelCaptions.slice(0, numberOfLabelsToShow), (caption, index) => {
            return (
              <li
                key={index}
                className="ProjectVersionsViewHeader__label"
              >
                <div className="ProjectVersionsViewHeader__label-caption">
                  {caption}
                </div>
              </li>
            )
          })}
          {numberOfLabelCaptions > numberOfLabelsToShow && (
            <li
              key={numberOfLabelsToShow}
              className="ProjectVersionsViewHeader__label"
            >
              <div className="ProjectVersionsViewHeader__label-caption">
                +{numberOfLabelCaptions - numberOfLabelsToShow}
              </div>
            </li>
          )}
        </ul>
      </div>
    )
  }

  return (
    <div
      className={classnames(
        'ProjectVersionsViewHeader',
        { 'ProjectVersionsViewHeader__full': fullProjectVersionsView}
      )}
    >
      {renderTitleAndStatus()}
      {renderLabels()}
    </div>
  )
}

export default ProjectVersionsViewHeader
